import { Assessment } from "@mui/icons-material";
import AssignmentReview from "../Containers/Academics/Pages/Activities/Assignment/Components/Preview";

const routes = {
  login: '/login',
  register: '/register',
  otp: '/otp',
  verified: '/otpverification',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  home: '/home',
  myProfile: '/my Profile',
  events: '/events',
  jobs: '/jobs',
  jobDetails: '/jobs',
  postJob: '/jobs/post-job',
  appliedJobs: '/jobs/appliedJobs',
  savedJobs: '/jobs/savedJobs',
  myJobs: '/jobs/myJobs',
  resumeLibrary: '/jobs/Resume-library',
  resumeBuilder: '/jobs/Resume-builder',
  mentorship: '/mentorship',
  setupPreference: '/mentorship/Set-up-your-preferences',
  mentorDetails: '/mentorship/Mentee-Details',
  fundraise: '/fundraise',
  fundraiseDetails: '/fundraise',
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  yourGroups: '/groups/Your-groups',
  createGroup: '/groups/create-group',
  network: '/network',
  survey: '/survey',
  yoursurvey: '/survey/yoursurvey',
  createSurvey: '/survey/create-survey',
  test: '/test',
  service: '/Service & Support',
  serviceFAQ: '/service & support/FAQ',
  RequestService: '/service & support/RequestService',
  Answers: '/service & support/RequestService',
  TicketPreview: '/service & support/Ticket-Preview',
  settings: '/settings',
  schedule: '/calendar',
  socialLinks: '/socialLinks',
  academics: '/academics',
  Addquestion:'/academics/add-question',
  academicsElaborate: '/academicsElaborate',
  resourceUpload: '/Resources',
  myStudents: '/My Students',
  courseElaborate: '/academics/Activities and Resources',
  attendance: '/attendance',
  mySchedule: '/My Schedule',
  studentDetails: '/My Students/Student Details/:id',
  studentInfo: '/My Students/Student Details/Student Info/:CourseOfferingID/:contactId',
  resourceEloboarate: '/Resource Elaborate',
  attendanceTabs: '/attendance/Faculty Courses/Session Attendance/:id',
  facultyCourses: '/attendance/Faculty Courses',
  overAllAttendance: '/attendance/over All Attendance',
  EditProfile: '/my Profile/edit Profile',
  AssessmentAdding: '/Assessment',
  AssignmentAdding: '/Assignment',
  ForumAdding: '/Forum',
  AssignmentReview: '/AssignmentReview',
  ForumDiscussion: '/ForumDiscussion',
  QuestionBank: '/QuestionBank',
  PlanMyProgram: '/Plan My Program',
  SessionPlanner: '/Plan My Program/Session Planner',
  SessionSummary: '/Plan My Program/Session Planner/Session Summary',
};


export default routes;
